import React, { lazy, Suspense } from "react";
import clsx from "clsx";
import makeStyles from "@material-ui/styles/makeStyles";
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Button = lazy(() => import(/* webpackChunkName: "reactButton" */ "../button"));

const useStyles = makeStyles(theme => ({
	root: {
		alignItems: "center",
		display: "flex",
		justifyContent: "center",
		position: "relative",
		"&:before": {
			background: "#BCB5AB",
			content: "''",
			display: "flex",
			height: 1,
			position: "absolute",
			width: "100%"
		},
		"& .button-custom": {
			background: "#FFFFFF",
			display: "flex",
			padding: theme.spacing(0, 1),
			zIndex: 1,
			[theme.breakpoints.up("md")]: {
				padding: theme.spacing(0, 4)
			}
		}
	}
}));

const ButtonElement = ({ label, link, parameter, target }) => {
	const css = useStyles();
	const theme = useTheme();
	const screenMD = useMediaQuery(theme.breakpoints.up("md"));
	let linkValue = link;

	if (link && parameter) {
		linkValue += `#buttonValue=` + parameter;
	}

	return (
		<div className={clsx("extension-button-element", css.root)}>
			<Suspense fallback={<></>}>
				<Button
					label={label}
					color="#FFFFFF"
					colorHover="#FFFFFF"
					link={linkValue}
					target={target}
					size={screenMD ? "large" : "small"}
					variant="contained"
				/>
			</Suspense>
		</div>
	);
};

export default ButtonElement;
